import { FC } from 'react';

import type { ArticleSubcategory } from '@/entities/article';
import { Icon } from '@/shared/ui';

import styles from './articleCategoryItem.module.scss';

interface ArticleCategoryItemProps {
  value: ArticleSubcategory;
  isActive: boolean;
  displayCount?: number;
  onClick: () => void;
}

const ArticleCategoryItem: FC<ArticleCategoryItemProps> = (props) => {
  const { value, isActive, displayCount, onClick } = props;
  return (
    <button
      aria-controls={`article-category-${value.id}`}
      aria-expanded={isActive}
      className={styles.container}
      type="button"
      onClick={onClick}
    >
      <div className={styles.container__countBlock}>
        <p className={styles.container__count}>
          {displayCount ?? value?.sort_order ?? 0}
        </p>
      </div>
      <div className={styles.container__textBlock}>
        <p className={styles.container__text}>{value.name}</p>
      </div>
      <Icon
        className={styles.container__icon}
        name={isActive ? 'minusSmall' : 'plusSmall'}
      />
    </button>
  );
};

export default ArticleCategoryItem;
